export enum ActualQuantity {
  /**
   * Zero elements
   */
  NONE,

  /**
   * Between one or all but one
   */
  ONE_OR_MORE,

  /**
   * All the elements
   */
  ALL,
}
